export type WidgetV2ListVariant = 'list' | 'boxes' | 'slidebox'
export type WidgetV2SearchVariant = 'horizontal' | 'box'
export type WidgetV2AdvancedSearchVariant = 'full' | 'accordion'
export type WidgetV2DetailVariant = 'horizontal' | 'box'

export function normalizeListVariant(value?: string | null): WidgetV2ListVariant {
  const raw = String(value ?? '').trim().toLowerCase()
  if (raw === 'boxes' || raw === 'box') return 'boxes'
  if (raw === 'slidebox' || raw === 'slider' || raw === 'carousel') return 'slidebox'
  return 'list'
}

export function normalizeSearchVariant(value?: string | null): WidgetV2SearchVariant {
  const raw = String(value ?? '').trim().toLowerCase()
  if (raw === 'box') return 'box'
  return 'horizontal'
}

export function normalizeAdvancedSearchVariant(value?: string | null): WidgetV2AdvancedSearchVariant {
  const raw = String(value ?? '').trim().toLowerCase()
  if (raw === 'accordion' || raw === 'collapsible' || raw === 'collapse') return 'accordion'
  if (raw === 'full' || raw === 'list') return 'full'
  return 'full'
}

export function normalizeDetailVariant(value?: string | null): WidgetV2DetailVariant {
  const raw = String(value ?? '').trim().toLowerCase()
  if (raw === 'box') return 'box'
  return 'horizontal'
}

/** Checkout-Darstellung: `inline` (Standard) oder eigenes Overlay (`modal`). */
export type WidgetV2DetailCheckoutVariant = 'inline' | 'modal'

export function normalizeDetailCheckoutVariant(value?: string | null): WidgetV2DetailCheckoutVariant {
  const raw = String(value ?? '').trim().toLowerCase()
  if (raw === 'modal' || raw === 'popup' || raw === 'dialog' || raw === 'checkout-modal') return 'modal'
  return 'inline'
}
